import BshMessage from './components/messages/message.js';
import bshValidation from './components/validation/validation.js';
import btnFunctions from './components/buttons/btnFunctions.js';
// tosted
import Toasted from 'vue-toasted';
export default function BshComponent() {

	// Dependencias
	Vue.use(Toasted, {
	    iconPack : 'fontawesome'
	});;
	
	// Components
	Vue.component('BshModal', require('./components/modal/Modal.vue').default);
	Vue.component('BshLoadCircle', require('./components/load/LoadCircle.vue').default);
	Vue.component('BshConfirm', require('./components/confirm/Confirm.vue').default);
	Vue.component('BshConfirmModal', require('./components/confirm/ConfirmModal.vue').default);
	Vue.component('BshCard', require('./components/cards/Card.vue').default);
	Vue.component('BshDatatable', require('./components/datatable/Datatable.vue').default);
	Vue.component('BshPaginate', require('./components/pagination/Paginate.vue').default);
	Vue.component('BshTab', require('./components/tab/Tab.vue').default);
	Vue.component('BshNav', require('./components/nav/Nav.vue').default);
	Vue.component('BshDropdownNav', require('./components/nav/DropdownNav.vue').default);
	Vue.component('showMessage', require('./components/messages/message.js').default);
	Vue.component('SelectTwo', require('./components/selectTwo/SelectTwo.vue').default);

	// Methods
	Vue.prototype.$bshMessage = BshMessage;
	Vue.prototype.$bshValidation = bshValidation;
	Vue.prototype.$btnFunctions = btnFunctions;
}